import { render, staticRenderFns } from "./SpecialDetail.vue?vue&type=template&id=73b17661&scoped=true"
import script from "./SpecialDetail.vue?vue&type=script&lang=js"
export * from "./SpecialDetail.vue?vue&type=script&lang=js"
import style0 from "./SpecialDetail.vue?vue&type=style&index=0&id=73b17661&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b17661",
  null
  
)

export default component.exports